/* LPA PDP Workshop: galeria, rezervarea si bara de pe mobil pentru sections/lpa-pdp-workshop.liquid. */
(function(){
  function init(){
    var root = document.getElementById('lpa-ws');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    function $(id){ return document.getElementById(id); }
    function arr(x){ return Array.prototype.slice.call(x); }

    /* ---------- Galerie: swipe pe mobil, miniaturi pe desktop ---------- */
    var track = $('pdpTrack');
    var slides = arr(track.querySelectorAll('.ws-slide'));
    var thumbs = arr(root.querySelectorAll('#pdpThumbs button'));
    var capEl = $('pdpCap'), nowEl = $('pdpNow'), current = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setCurrent(i){
      if (i === current || !slides[i]) return;
      current = i;
      thumbs.forEach(function(t, n){ t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      capEl.textContent = slides[i].getAttribute('data-cap') || '';
      nowEl.textContent = i + 1;
    }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ goTo(i); }); });
    var ticking = false;
    track.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        if (track.clientWidth) setCurrent(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))));
      });
    }, { passive: true });
    track.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight'){ e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft'){ e.preventDefault(); goTo(current - 1); }
    });
    window.addEventListener('resize', function(){ track.scrollLeft = current * track.clientWidth; });

    /* ---------- Rezervare: data, locuri, total ---------- */
    var form = $('pdpForm');
    var TOTAL = parseInt(root.getAttribute('data-total'), 10) || 8;
    var T1 = root.getAttribute('data-rezerva') || 'Rezervă';
    var TN = root.getAttribute('data-rezerva-n') || T1;
    var MF = root.getAttribute('data-money') || '';
    var NB = String.fromCharCode(160);
    var dateBtns = arr(root.querySelectorAll('#pdpSizes button'));
    var qtyOut = $('pdpQty'), qtyIn = $('pdpQtyInput'), varIn = $('pdpVariant');
    var burn = $('pdpBurn'), qNote = $('pdpQNote'), atc = $('pdpAtc'), priceEl = $('pdpPriceVal');
    var qb = root.querySelectorAll('.ws-qty button'), minus = qb[0], plus = qb[1];
    var bar = $('pdpBar'), barBtn = $('pdpBarBtn'), barDate = $('pdpBarDate'), barSeats = $('pdpBarSeats');
    var qty = 1, selected = null;

    function left(b){ return Math.max(0, parseInt(b.getAttribute('data-left'), 10) || 0); }
    function seats(n){ return n === 1 ? '1 loc' : n + ' locuri'; }
    /* Formateaza suma (in bani) dupa formatul de moneda al magazinului, fara zecimale cand suma e rotunda. */
    function money(c){
      var a = MF.indexOf('{' + '{'), z = MF.indexOf('}' + '}');
      var kind = a > -1 && z > a ? MF.slice(a + 2, z) : '';
      var comma = kind === '' || kind.indexOf('comma') > -1;
      var n = String(Math.floor(c / 100)), out = '';
      for (var i = n.length; i > 0; i -= 3){ out = n.slice(Math.max(0, i - 3), i) + (out ? (comma ? '.' : ',') + out : ''); }
      if (c % 100 !== 0){ out += (comma ? ',' : '.') + ('0' + Math.round(c % 100)).slice(-2); }
      return kind ? MF.slice(0, a) + out + MF.slice(z + 2) : out + ' lei';
    }

    dateBtns.forEach(function(b){
      var n = left(b);
      if (n === 0) b.disabled = true;
      b.querySelector('em').textContent = b.disabled ? (b.getAttribute('data-off') || 'Complet rezervat') : (n === 1 ? '1 loc disponibil' : n + ' locuri disponibile');
      b.setAttribute('aria-pressed', 'false');
    });

    function render(){
      if (!selected){
        qty = 1;
        qtyOut.textContent = '1';
        minus.disabled = plus.disabled = atc.disabled = barBtn.disabled = true;
        atc.textContent = 'Toate sesiunile sunt complete';
        barBtn.textContent = 'Complet';
        burn.textContent = 'Momentan nu mai sunt locuri disponibile.';
        qNote.textContent = '';
        barDate.textContent = 'Complet rezervat';
        barSeats.textContent = '';
        return;
      }
      var max = left(selected);
      var price = parseInt(selected.getAttribute('data-price'), 10) || 0;
      qty = Math.max(1, Math.min(max, qty));
      qtyOut.textContent = qty;
      qtyIn.value = qty;
      varIn.value = selected.getAttribute('data-variant');
      minus.disabled = qty <= 1;
      plus.disabled = qty >= max;
      burn.textContent = max === 1 ? 'A mai rămas 1 loc din ' + TOTAL + '.' : 'Au mai rămas ' + max + ' locuri din ' + TOTAL + '.';
      qNote.textContent = max === 1 ? 'Un singur loc la această sesiune' : 'Maximum ' + max + ' locuri la această sesiune';
      if (priceEl) priceEl.textContent = money(price);
      atc.textContent = (qty === 1 ? T1 : TN + ' ' + qty + ' locuri') + ' ' + NB + '·' + NB + ' ' + money(qty * price);
      barBtn.textContent = TN + ' · ' + money(qty * price);
      barDate.textContent = selected.getAttribute('data-short');
      barSeats.textContent = seats(qty);
    }
    function select(b){
      selected = b;
      dateBtns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      render();
    }
    dateBtns.forEach(function(b){
      b.addEventListener('click', function(){ if (!b.disabled) select(b); });
    });
    [minus, plus].forEach(function(b){
      b.addEventListener('click', function(){
        qty += parseInt(b.getAttribute('data-d'), 10);
        render();
      });
    });
    if (form) form.addEventListener('submit', function(e){ if (!selected) e.preventDefault(); });

    var first = dateBtns.filter(function(b){ return !b.disabled; })[0];
    if (first) select(first); else render();

    /* ---------- Bara de rezervare pe mobil: apare cand butonul principal a iesit din ecran, in sus ---------- */
    var barOn = false, barTick = false;
    function syncBar(){
      var on = atc.getBoundingClientRect().bottom < 0;
      if (on === barOn) return;
      barOn = on;
      bar.classList.toggle('ws-is-on', on);
      document.documentElement.classList.toggle('ws-bar-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      barBtn.tabIndex = on ? 0 : -1;
    }
    window.addEventListener('scroll', function(){
      if (barTick) return;
      barTick = true;
      requestAnimationFrame(function(){ barTick = false; syncBar(); });
    }, { passive: true });
    syncBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
